import React, { Fragment, useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import AddButton, { DraftButton } from "../buttons/button";
import ModalCloseIcon from "../../assets/icons/modal-close-icon";

const SaveReportModal = ({
  isOpen,
  onClose,
  onSave,
  initialName = "",
  initialDescription = "",
  initialIsShared = false,
  isEdit = false,
  loading = false,
}) => {
  const [name, setName] = useState(initialName);
  const [description, setDescription] = useState(initialDescription);
  const [isShared, setIsShared] = useState(initialIsShared);

  useEffect(() => {
    setName(initialName);
    setDescription(initialDescription);
    setIsShared(initialIsShared);
  }, [initialName, initialDescription, initialIsShared, isOpen]);

  const handleSave = () => {
    if (!name.trim()) return;
    onSave({ name: name.trim(), description: description.trim(), is_shared: isShared });
  };

  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog as="div" className="fixed inset-0 z-50 overflow-y-auto" onClose={onClose}>
        <div className="flex min-h-screen items-center justify-center px-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-100"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-60" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4"
            enterTo="opacity-100 translate-y-0"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-4"
          >
            <div className="relative bg-white rounded-xl shadow-xl w-full max-w-md">
              <div
                className="px-6 py-4 flex items-center justify-between rounded-t-xl"
                style={{ backgroundColor: "#F4F6F9" }}
              >
                <label className="text-sm fw_600">
                  {isEdit ? "Update Report" : "Save Report"}
                </label>
                <ModalCloseIcon className="cursor-pointer" onClick={onClose} />
              </div>

              <div className="p-6 space-y-4">
                <div>
                  <label className="block text-xs fw_500 text-344054 mb-1">
                    Report Name <span className="text-F51D00">*</span>
                  </label>
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter report name"
                    className="w-full px-3 py-2 border border-D0D5DD rounded-md text-sm focus:outline-none focus:border-primary"
                  />
                </div>

                <div>
                  <label className="block text-xs fw_500 text-344054 mb-1">Description</label>
                  <textarea
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Enter description (optional)"
                    rows={3}
                    className="w-full px-3 py-2 border border-D0D5DD rounded-md text-sm focus:outline-none focus:border-primary resize-none"
                  />
                </div>

                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="isShared"
                    checked={isShared}
                    onChange={(e) => setIsShared(e.target.checked)}
                    className="w-4 h-4 text-primary border-D0D5DD rounded focus:ring-primary"
                  />
                  <label htmlFor="isShared" className="text-xs text-344054">
                    Share with store members
                  </label>
                </div>
              </div>

              <div className="px-6 py-4 flex justify-end gap-3 border-t border-EAECF0">
                <DraftButton text="Cancel" onclkFn={onClose} />
                <AddButton
                  text={isEdit ? "Update" : "Save"}
                  prefixIcon={false}
                  onclkFn={handleSave}
                  isDisabled={!name.trim()}
                  loading={loading}
                />
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default SaveReportModal;
